import { BaseError } from './BaseError';

export class FileSizeExceededError extends BaseError {
  constructor({ maximum, actual }: { maximum: number; actual: number }) {
    super(`Maximum allowed file size is ${maximum} MB. Received ${actual} MB file size.`);
  }
}
